<template>
  <div class="crud_form_wrapper">
    <!-- Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showOrder") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- Order Details Form -->
    <div class="single_step_form_content_wrapper">
      <div v-if="!isOrderLoading">
        <form>
          <div class="row">
          <h2>{{ $t("PLACEHOLDERS.orderDetails") }}</h2>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderNum')"
            v-model="data.orderNum"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderCreate')"
            v-model="data.orderCreate"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderStatus')"
            v-model="data.status"
            disabled
          />

          <h2>{{ $t("PLACEHOLDERS.userData") }}</h2>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model="data.userName"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.userMobile"
            disabled
          />

          <h2>{{ $t("PLACEHOLDERS.serviceData") }}</h2>
          <div class="preview-container text-center my-3">
            <img
              v-if="data.serviceImage"
              :src="data.serviceImage"
              :alt="$t('PLACEHOLDERS.serviceImage')"
              class="service-image"
            />
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.serviceName')"
            v-model="data.serviceName"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.servicePrice')"
            v-model="data.servicePrice"
            disabled
          />
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.notes')"
            v-model="data.notes"
            disabled
          />

          <h2>{{ $t("PLACEHOLDERS.addressDetails") }}</h2>
          <MapComponent
            :lat="parseFloat(data.lat)"
            :lng="parseFloat(data.lng)"
            disabled
          />

          <h2>{{ $t("PLACEHOLDERS.paymentData") }}</h2>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.paymentMethod')"
            v-model="data.paymentType"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalPriceService')"
            v-model="data.subTotal"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalDeliveryFee')"
            v-model="data.deliveryFee"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalOrderPrice')"
            v-model="data.totalOrderPrice"
            disabled
          />

          <base-input
            v-if="data.cancelReason"
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cancelReason')"
            v-model="data.cancelReason"
            disabled
          />
          <base-input
            v-if="data.cancelDate"
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cancelDate')"
            v-model="data.cancelDate"
            disabled
          />
          </div>
        </form>

        <!-- Sub Services / Products In Order - at bottom of page -->
        <div
          v-if="data.subServices && data.subServices.length"
          class="mt-6"
        >
          <h2 class="mb-3">
            {{ $t("PLACEHOLDERS.subServices") }}
          </h2>
          <v-simple-table class="order-sub-services-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    {{ $t("PLACEHOLDERS.serviceName") }}
                  </th>
                  <th class="text-center">
                    {{ $t("PLACEHOLDERS.servicePrice") }}
                  </th>
                  <th class="text-center">
                    {{ $t("PLACEHOLDERS.serviceType") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="sub in data.subServices"
                  :key="sub.id"
                >
                  <td class="text-center">
                    {{ sub.name || "-" }}
                  </td>
                  <td class="text-center">
                    {{ sub.price != null ? sub.price : "-" }}
                  </td>
                  <td class="text-center">
                    {{
                      sub.type === 'main_service'
                        ? $t("PLACEHOLDERS.mainService")
                        : $t("PLACEHOLDERS.subService")
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div v-else class="d-flex justify-content-center my-5">
        <v-progress-circular
          indeterminate
          color="#3eb6d4"
          :size="40"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MapComponent from "@/components/general/MapComponent.vue";

export default {
  components: { MapComponent },

  data() {
    return {
      isOrderLoading: false,
      data: {
        orderNum: "",
        orderCreate: "",
        status: "",
        userName: "",
        userMobile: "",
        serviceName: "",
        servicePrice: "",
        serviceImage: "",
        notes: "",
        subServices: [],
        lat: null,
        lng: null,
        paymentType: "",
        subTotal: "",
        deliveryFee: "",
        totalOrderPrice: "",
        cancelReason: "",
        cancelDate: "",
      

},
    };
  },

  async created() {
    await this.fetchOrder();
  },

  methods: {
    async fetchOrder() {
      try {
        this.isOrderLoading = true;
        const res = await this.$axios.get(`orders/${this.$route.params.id}`);
        const order = res.data.data.Order;

        this.data.orderNum = order.serial_number;
        this.data.orderCreate = order.created_at;
        this.data.status = order._status;

        this.data.userName = order.user_name;
        this.data.userMobile = order.user_mobile;

        this.data.serviceName = order.main_service?.name;
        this.data.servicePrice = order.main_service?.price;
        this.data.serviceImage = order.main_service?.image || "";

        // Build services table: include main service row + sub services
        const subServices = Array.isArray(order.sub_services)
          ? order.sub_services
          : [];

        if (order.main_service) {
          subServices.unshift({
            id: order.main_service.id,
            name: order.main_service.name,
            price: order.main_service.price,
            type: order.main_service.type || "main_service",
          });
        }

        this.data.subServices = subServices;

        this.data.notes = order.notes || "";

        this.data.lat = order.lat;
        this.data.lng = order.lng;

        this.data.paymentType = order._payment_method;
        this.data.subTotal = order.sub_total;
        this.data.deliveryFee = order.delivery_fee;
        this.data.totalOrderPrice = order.total;

        this.data.cancelReason = order.cancel_reason || "";
        this.data.cancelDate = order.cancel_date || "";
      } catch (err) {
        console.error("Error fetching order:", err.response?.data?.message || err);
      } finally {
        this.isOrderLoading = false;
      }
    },
  },
};
</script>

<style>
.service-image {
  max-width: 200px;
  border-radius: 6px;
}

.order-sub-services-table {
  border-radius: 8px;
  overflow: hidden;
  background-color: var(--theme_main_bg_clr);
  color: var(--theme_text_clr);
}

.order-sub-services-table thead tr {
  background-color: var(--main_theme_clr);
}

.order-sub-services-table thead th {
  color: #fff;
  font-weight: 600;
}

.order-sub-services-table tbody tr {
  background-color: var(--theme_main_bg_clr);
  transition: background-color 0.3s linear;
}

.order-sub-services-table tbody tr:nth-child(even) {
  background-color: var(--theme_second_bg_clr);
}

.order-sub-services-table tbody tr:hover {
  background-color: var(--theme_second_bg_clr);
}

.order-sub-services-table tbody td {
  color: var(--theme_text_clr);
  border-color: transparent;
}
</style>
